import { Component, OnInit } from '@angular/core';
import { Tab } from 'src/app/interfaces/tabs-program/tabs-program.interface';
import { AuthService } from 'src/app/services/api/auth/auth.service';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-shell-program',
  templateUrl: './shell-program.component.html',
  styleUrls: ['./shell-program.component.scss'],
})
export class ShellProgramComponent implements OnInit {
  isMobile: boolean = window.innerWidth <= 1000;
  bannerDesktop = '../../../assets/images/banner/BannerProgramDesktop.jpg';
  bannerMobile = '../../../assets/images/banner/BannerProgramMobile.jpg';
  desktopImageRegister = '../../../assets/images/BannerDesktopRegister.png';
  mobileImageRegister = '../../../assets/images/BannerMobileRegister.jpg';
  isPlayingFirst = false;
  isPlayingSecond = false;
  showAll = false;

  benefits = [
    { numero: 1, descripcion: 'Sumar puntos pagando con la App o presentando tu DNI' },
    { numero: 2, descripcion: 'Canjear tus puntos por descuentos' },
    { numero: 3, descripcion: 'Acceder a beneficios exclusivos' },
  ];

  selectedTab = 'firstTab';

  tabs: Tab[] = [
    { 
      id: 'firstTab', title: 'Combustibles', 
      image: '../../../assets/icon/icon-pump.svg',  
      activeImage: "../../../assets/icon/icon-shell-v-power-weight.svg",
      boxContent: [
        { name: 'Shell V-Power Nafta', details: ['1 litro', '4 puntos'] },
        { name: 'Shell V-Power Diesel', details: ['1 litro', '4 puntos'] },
        { name: 'Shell Fórmula Super', details: ['1 litro', '2 puntos'] }
      ]
    },
    { 
      id: 'secondTab', title: 'Lubricantes', 
      image: '../../../assets/icon/icon-lubricant-grey.svg',  
      activeImage: "../../../assets/icon/icon-lubricant-weight.svg",
      boxContent: [
        { name: 'Premium', details: ['1 Unidad', '250 puntos'] },
        { name: 'Regulares', details: ['1 Unidad', '100 puntos'] },
      ]
    },
    { 
      id: 'thirdTab', title: 'Lubricantes marca', 
      image: '../../../assets/icon/icon-lubricant-grey.svg',  
      activeImage: "../../../assets/icon/icon-lubricant-weight.svg",
      boxContent: [
        { 
          brand: {
            name: 'Shell Rimula',
            type: 'Premium',
            variants: ['R6 & R5E', '1, 4 y 20 Litros'],
            secondType: {
              type: 'Regular',
              variants: ['R6 & R5E', '1, 4 y 20 Litros']
            }
          }
        },
        { 
          brand: {
            name: 'Shell Helix',
            type: 'Premium',
            variants: ['ULTRA, *HX8 *& HX7', '1, 4 y 20 Litros'],
            secondType: {
              type: 'Regular',
              variants: ['HX5 & HX3', '1, 4 y 20 Litros']
            }
          }
        },
        { 
          brand: {
            name: 'Shell Advance',
            type: 'Premium',
            variants: ['ULTRA & AX7', '1 Litro'],
            secondType: {
              type: 'Regular',
              variants: ['AX5 & SX2', '1 Litro']
            }
          }
        }
      ]
    },
    { 
      id: 'fourthTab', title: 'Tienda Shell', 
      image: '../../../assets/icon/icon-shop-shell-grey.svg',  
      activeImage: "../../../assets/icon/icon-shell-select-weight.svg",
      boxContent: [
        { name: 'Con cada compra*', details: ['$50  ', '1 punto'], minimum: ['*Mínimo de compra $150'] },
      ]
    }
  ];
  

  pointsList = [
    { firstText: "$800 de descuento", secondText: "550 puntos Shell Box" },
    { firstText: "$1600 de descuento", secondText: "1100 puntos Shell Box" },
    { firstText: "$2400 de descuento", secondText: "1650 puntos Shell Box" },
    { firstText: "$3200 de descuento", secondText: "2200 puntos Shell Box" },    
    { firstText: "$4800 de descuento", secondText: "3300 puntos Shell Box" }
  ];  

  typesSellerList = [
    {
      title: "En el Market Shell",
      icon: "../../../assets/icon/icon-travel-program.svg",
      linkText: "Ver productos",
      linkUrl: "https://marketshell.shell.com.ar/"
    },
    {
      title: "Para viajar",
      icon: "../../../assets/icon/icon-market-shell-program.svg",
      linkText: "Ver conversor",
      linkUrl: "/conversor"
    }
  ];
  
  typeExchangesList = [
    { icon: "../../../assets/icon/icon-lubricant.svg", label: "Lubricantes" },
    { icon: "../../../assets/icon/icon-shell-v-power.svg", label: "Combustibles" },
    { icon: "../../../assets/icon/icon-shell-select.svg", label: "Tienda Shell" }
  ];


  imagesList = [
    { src: "../../../assets/images/pointValue.svg"},
    { src: "../../../assets/images/exclusiveBenefits.svg" },
    { src: "../../../assets/images/pointsExchange.svg" }
  ];

  imagesListMobile = [
    { src: "../../../assets/images/pointValueMobile.svg"},
    { src: "../../../assets/images/exclusiveBenefitsMobile.svg" },
    { src: "../../../assets/images/pointsExchangeMobile.svg" }
  ];

  desktopImage: string = "../../../assets/images/addPointsDesktop.jpg";
  mobileImage: string = "../../../assets/images/addPointsMobile.jpg";

  configPoints: SwiperOptions = {
    pagination: { clickable: true },
    slidesPerView: 1.3,
    spaceBetween: 10,
    centeredSlides: true,
  };
  
  
  constructor(private authService: AuthService) {}

  ngOnInit(): void {}

  selectTab(tabId: string) {
    this.selectedTab = tabId;
  }

  toggleBenefits() {
    this.showAll = !this.showAll;
  }

  getBoxContent() {
    return this.tabs.find(tab => tab.id === this.selectedTab)?.boxContent || [];
  }

  toggleVideo(videoElement: HTMLVideoElement, videoNumber: number) {
    if (videoNumber === 1) {
      if (videoElement.paused) {
        videoElement.play();
        this.isPlayingFirst = true;
      } else {
        videoElement.pause();
        this.isPlayingFirst = false;
      }
    } else if (videoNumber === 2) {
      if (videoElement.paused) {
        videoElement.play();
        this.isPlayingSecond = true;
      } else {
        videoElement.pause();
        this.isPlayingSecond = false;
      }
    }
  }

  getStoreLink(): string {
    if (/android/i.test(navigator.userAgent)) {
      return 'https://play.google.com/store/apps/details?id=com.raizen.acelera&pli=1';
    } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      return 'https://apps.apple.com/ar/app/shell-box-pague-e-ganhe/id1037433060';
    }
    return '';
  }

  downloadApp() {
    const storeLink = this.getStoreLink();
    if (storeLink) {
      window.location.href = storeLink;
    }
  }

  handleRegister() {
    if (!this.authService.loggedIn) {
      document
        .getElementsByClassName('modal-register')[0]
        .classList.add('visible');
      document.getElementsByTagName('body')[0].classList.add('noScroll');
    }
  }

  handleConversor() {
    if (this.authService.loggedIn) {
      window.location.replace('/conversor');
    } else {
      document
        .getElementsByClassName('modal-register')[0]
        .classList.add('visible');
      document.getElementsByTagName('body')[0].classList.add('noScroll');
    }
  }
}
